export function telephonyCallsRedirectTarget(search: string) {
  if (!search) return '/calls';
  return `/calls${search.startsWith('?') ? search : `?${search}`}`;
}
